<!-- privileges='RL_UPDATE_LIST_PRIVILEGE' hierarchy={{::item.hierarchy}} *ngIf="!sectionMenu.displayed || !markAndDrop.countCitationsItemsToMove(item) || !isOpenMyBag()" ng-show="!showImportToSection"  -->
<div class="drag-item-holder drag-section-item" [tooltip]="'action.drag.section' | translate" tooltip-placement="auto" attr.aria-label="{{'action.drag.section' | translate}}">
    <div class="drag-item-inner-content">
        <div class="drag-item top ignore-elements" *ngIf="order != minOrder">
            <button class="btn btn-primary" (click)="updateOrder(order - 1)">
                <span class="sr-only">{{'section.action.move_up' | translate}}</span>
                <i class="fa fa-chevron-up" attr.aria-hidden="true"></i>
            </button>
        </div>
        <div class="drag-item-btn drag-section"></div>
        <div class="drag-item bottom" *ngIf="order != maxOrder">
            <button class="btn btn-primary" (click)="updateOrder(order + 1)">
                <span class="sr-only">{{'section.action.move_down' | translate}}</span>
                <i class="fa fa-chevron-down" attr.aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>